import React from 'react'

/**
 * Escape hatch for schools and districts whose needs do not fit the self-serve plan — a different
 * seat count, extra teachers or schools, or a specific timeline.
 */
function CustomPlanPanel() {
  return (
    <div className='mt-6 flex flex-col items-start gap-4 rounded-2xl border border-line-200 bg-white p-6 shadow-card sm:flex-row sm:items-center'>
      <div className='flex-1'>
        <h3 className='font-display text-15 font-bold text-ink'>
          Need a Custom Plan?
        </h3>
        <p className='mt-1.5 text-13 leading-relaxed text-ink-500'>
          Every school and district is different. If you need a custom number of
          seats, teachers, schools, or a specific timeline, we can build a plan
          that works for you.
        </p>
      </div>
      <a
        href='mailto:sales@xtramath.org?subject=Custom%20Plan%20Enquiry'
        className='shrink-0 rounded-pill border border-line-200 bg-white px-6 py-2.5 font-display text-13 font-bold text-ink no-underline transition hover:border-line-300'
      >
        Talk to us
      </a>
    </div>
  )
}

export default CustomPlanPanel
